import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import MobileInfoBanner from "./components/feature/MobileInfoBanner";
import { PharmacyProvider } from "./context/PharmacyContext";


function App() {
  return (
    <PharmacyProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="min-h-screen overflow-x-hidden">
          <AppRoutes />
          <MobileInfoBanner />
        </div>
      </BrowserRouter>
    </PharmacyProvider>
  );
}

export default App;